export default function MidpointMediaSetupPanel({ instructions, error }) {
  if (!instructions) {
    return null;
  }

  return (
    <section className="mm-admin-card mm-admin-setup">
      <div className="mm-admin-badge mm-admin-badge--demo">Needs configuration</div>
      <h3>{instructions.title}</h3>
      <p className="mm-admin-lead">{instructions.summary}</p>
      {error ? <p className="admin-data-health-error">{error}</p> : null}
      {Array.isArray(instructions.steps) ? (
        <ol>
          {instructions.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      ) : null}
      {Array.isArray(instructions.env) && instructions.env.length ? (
        <pre className="mm-admin-env">
          {instructions.env
            .map((item) => `${item.name}=${item.example || ""}${item.required ? "" : "  # optional"}`)
            .join("\n")}
        </pre>
      ) : null}
    </section>
  );
}
